(function () {
  if (window.__abrsmUtilityDockBound) return;
  window.__abrsmUtilityDockBound = true;

  /* --- Gorgias: initialize only when chat is requested --------------- */
  var gorgiasReady = null;
  var gorgiasStateBound = false;
  window.__abrsmGorgiasOpen = false;

  function bindGorgiasState(chat) {
    if (gorgiasStateBound || !chat || typeof chat.on !== "function") return;

    try {
      chat.on("widget:opened", function () {
        window.__abrsmGorgiasOpen = true;
      });
      chat.on("widget:closed", function () {
        window.__abrsmGorgiasOpen = false;
      });
      gorgiasStateBound = true;
    } catch (e) {
      console.warn("ABRSM utility dock: cannot subscribe to Gorgias events", e);
    }
  }

  function getGorgiasReady() {
    if (window.GorgiasChat) {
      bindGorgiasState(window.GorgiasChat);
      return Promise.resolve(window.GorgiasChat);
    }

    if (gorgiasReady) return gorgiasReady;

    gorgiasReady = new Promise(function (resolve) {
      var timeoutId;

      function done() {
        window.clearTimeout(timeoutId);
        var chat = window.GorgiasChat || null;
        bindGorgiasState(chat);
        resolve(chat);
      }

      window.addEventListener("gorgias-widget-loaded", done, { once: true });
      timeoutId = window.setTimeout(done, 8000);
    });

    return gorgiasReady;
  }

  function dispatchMouseClick(node) {
    if (!node) return false;

    try {
      if (typeof node.focus === "function") {
        node.focus({ preventScroll: true });
      }
    } catch (e) {}

    try {
      if (typeof node.click === "function") {
        node.click();
        return true;
      }
    } catch (e) {}

    try {
      ["pointerdown", "mousedown", "mouseup", "click"].forEach(function (eventName) {
        node.dispatchEvent(
          new MouseEvent(eventName, {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function findFirstOutsideDock(selector) {
    var nodes = document.querySelectorAll(selector);
    if (!nodes || !nodes.length) return null;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node.closest("[data-abrsm-utility-dock]")) {
        return node;
      }
    }

    return null;
  }

  function callFirstMethod(targets, methodNames) {
    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      if (!target) continue;

      for (var j = 0; j < methodNames.length; j++) {
        var methodName = methodNames[j];
        if (typeof target[methodName] !== "function") continue;

        try {
          target[methodName]();
          return true;
        } catch (e) {}
      }
    }

    return false;
  }

  function openCookiePreferences() {
    var apiTargets = [
      window.privacyBanner,
      window.Shopify && window.Shopify.privacyBanner,
      window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.privacyBanner,
      window.CookieYes,
      window.cookieyes,
      window.cky,
      window.ckyConsent,
      window.CKY
    ];
    var apiMethods = [
      "showPreferences",
      "openPreferences",
      "showPreferenceCenter",
      "openPreferenceCenter",
      "openDialog",
      "showDialog",
      "loadBanner",
      "show",
      "open"
    ];

    if (callFirstMethod(apiTargets, apiMethods)) {
      return true;
    }

    var cookieTrigger = findFirstOutsideDock(
      [
        ".cky-btn-revisit-wrapper",
        ".cky-revisit-bottom-left",
        ".cky-revisit-bottom-right",
        '[data-cky-tag="revisit-consent"]',
        '[data-cky-tag="detail"]',
        "#shopify-pc__banner__btn-manage-prefs",
        ".shopify-pc__banner__btn-manage-prefs"
      ].join(", ")
    );

    if (dispatchMouseClick(cookieTrigger)) {
      return true;
    }

    var bannerTrigger = findFirstOutsideDock(".cky-banner-element");
    if (dispatchMouseClick(bannerTrigger)) {
      return true;
    }

    console.warn("ABRSM utility dock: cookie preferences trigger not found");
    return false;
  }

  function updateDockOffsetForCookieBanner() {
    var banner = document.getElementById("shopify-pc__banner");
    var offset = 0;

    if (banner) {
      var bannerStyle = window.getComputedStyle(banner);
      var bannerRect = banner.getBoundingClientRect();
      if (
        bannerStyle.display !== "none" &&
        bannerStyle.visibility !== "hidden" &&
        bannerRect.height > 0
      ) {
        offset = Math.ceil(bannerRect.height + 16);
      }
    }

    var nextOffset = offset + "px";
    if (document.documentElement.style.getPropertyValue("--abrsm-cookie-banner-offset") !== nextOffset) {
      document.documentElement.style.setProperty("--abrsm-cookie-banner-offset", nextOffset);
    }

    updateDockReserve();
  }

  function updateDockReserve() {
    var dock = document.querySelector("[data-abrsm-utility-dock]");
    var reserve = 0;

    if (dock) {
      var layoutMode = dock.getAttribute("data-layout");
      var layout = layoutMode
        ? dock.querySelector(".abrsm-utility-dock__layout--" + layoutMode)
        : null;

      if (layout) {
        var layoutStyle = window.getComputedStyle(layout);
        var layoutRect = layout.getBoundingClientRect();
        if (layoutStyle.display !== "none" && layoutRect.height > 0) {
          reserve = Math.max(0, Math.ceil(window.innerHeight - layoutRect.top));
        }
      }
    }

    var nextReserve = reserve + "px";
    if (document.documentElement.style.getPropertyValue("--abrsm-utility-dock-reserve") !== nextReserve) {
      document.documentElement.style.setProperty("--abrsm-utility-dock-reserve", nextReserve);
    }
  }

  function announceUtilityDockInteraction(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {}
  }

  var cookieOffsetFrame = null;

  function scheduleCookieBannerOffset(delay) {
    if (delay) {
      window.setTimeout(function () {
        scheduleCookieBannerOffset(0);
      }, delay);
      return;
    }

    if (cookieOffsetFrame !== null) return;

    cookieOffsetFrame = window.requestAnimationFrame(function () {
      cookieOffsetFrame = null;
      updateDockOffsetForCookieBanner();
    });
  }

  /* --- Mini FAB toggle & click-outside ------------------------------- */
  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;

    /* Mini FAB */
    var fab = target.closest("[data-abrsm-utility-fab]");
    if (fab) {
      var dock = fab.closest("[data-abrsm-utility-dock]");
      if (dock && dock.getAttribute("data-layout") === "mini") {
        event.preventDefault();
        var isOpen = dock.getAttribute("data-menu-open") === "true";
        dock.setAttribute("data-menu-open", isOpen ? "false" : "true");
        fab.setAttribute("aria-expanded", isOpen ? "false" : "true");
        announceUtilityDockInteraction("abrsm-utility-dock:toggle", { open: !isOpen });
      }
      return;
    }

    /* Click outside mini dock closes it */
    var openMiniDock = document.querySelector(
      '[data-abrsm-utility-dock][data-layout="mini"][data-menu-open="true"]'
    );
    if (openMiniDock && !openMiniDock.contains(target)) {
      openMiniDock.setAttribute("data-menu-open", "false");
      var openFab = openMiniDock.querySelector("[data-abrsm-utility-fab]");
      if (openFab) {
        openFab.setAttribute("aria-expanded", "false");
      }
      announceUtilityDockInteraction("abrsm-utility-dock:toggle", { open: false });
    }

    /* Live chat toggle */
    var chatTrigger = target.closest("[data-abrsm-open-chat]");
    if (chatTrigger) {
      event.preventDefault();
      announceUtilityDockInteraction("abrsm-utility-dock:engage", { tool: "chat" });
      getGorgiasReady().then(function (chat) {
        if (!chat) return;
        try {
          if (window.__abrsmGorgiasOpen && typeof chat.close === "function") {
            chat.close();
          } else if (typeof chat.open === "function") {
            chat.open();
          } else if (typeof chat.toggle === "function") {
            chat.toggle();
          }
        } catch (e) {
          console.error("ABRSM utility dock: error toggling Gorgias chat", e);
        }
      });
      return;
    }

    var cookieTrigger = target.closest("[data-abrsm-open-cookies]");
    if (cookieTrigger) {
      event.preventDefault();
      announceUtilityDockInteraction("abrsm-utility-dock:engage", { tool: "cookies" });
      openCookiePreferences();
      scheduleCookieBannerOffset(0);
      scheduleCookieBannerOffset(250);
      scheduleCookieBannerOffset(1000);
      return;
    }

    var accessibilityTrigger = target.closest("[data-abrsm-open-accessibility]");
    if (accessibilityTrigger) {
      announceUtilityDockInteraction("abrsm-utility-dock:engage", { tool: "accessibility" });
      if (!window.accessWidget && !window.acsbJS && !window.acsb && !window.AccessiBe) {
        console.warn("ABRSM utility dock: accessibility widget runtime not ready");
      }
      return;
    }

    if (
      target.closest(
        "#shopify-pc__banner, #shopify-pc__prefs__dialog, .cky-consent-container, .cky-modal"
      )
    ) {
      scheduleCookieBannerOffset(0);
      scheduleCookieBannerOffset(250);
    }
  });

  updateDockOffsetForCookieBanner();
  window.addEventListener("resize", function () {
    scheduleCookieBannerOffset(0);
    updateDockReserve();
  }, { passive: true });

  function refreshCookieOffsetAfterLoad() {
    scheduleCookieBannerOffset(0);
    scheduleCookieBannerOffset(500);
    scheduleCookieBannerOffset(2000);
  }

  if (document.readyState === "complete") {
    refreshCookieOffsetAfterLoad();
  } else {
    window.addEventListener("load", refreshCookieOffsetAfterLoad, { once: true });
  }

  updateDockReserve();
})();
